import App from "./App";
import WorkExperience from "./Work";
import Education from "./Education";

function Experience() {
  return (
    <App>
      <WorkExperience />
      <br />
      <Education />
    </App>
  );
}

export default Experience;
